import { render, staticRenderFns } from "./ConfigHelpdeskGrupos.vue?vue&type=template&id=5781f86d&"
import script from "./ConfigHelpdeskGrupos.vue?vue&type=script&lang=js&"
export * from "./ConfigHelpdeskGrupos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports